import { createI18n } from 'vue-i18n'
import en from '@/locales/en.json'
import no from '@/locales/no.json'
import { datetimeFormats } from '@/i18n/datetime'
import { numberFormats } from '@/i18n/numbers'
import { pluralRules } from '@/i18n/pluralization'
import { DEFAULT_LOCALE } from '@/router/locales'

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  datetimeFormats,
  numberFormats,
  pluralRules,
  messages: { 
    en, 
    no 
  }
})
